import React, { useState, useEffect } from "react";
import { getVCMS, analytics } from "../../api/api";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "../pages/search.css";

const VideoReport = (props) => {
  const [search, setSearch] = useState(false);
  const [searchOn, setSearchOn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState([]);
  const [editing, setEditing] = useState([]);
  const [myArray, setMyArray] = useState([]);
  const [media, setMedia] = useState([]);
  const [fday, setFday] = useState([]);
  const [fmonth, setFmonth] = useState([]);
  const [fyear, setFyear] = useState([]);
  const [tday, setTday] = useState([]);
  const [tmonth, setTmonth] = useState([]);
  const [tyear, setTyear] = useState([]);
  const [number, setNumber] = useState(0);
  const [time, setTime] = useState("");

  useEffect(() => {
    const videoDetail = async () => {
      const result = await getVCMS().then(
        (result) => {
          setEditing(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
    };

    const mediaId = async (
      fyear,
      fmonth,
      fday,
      tyear,
      tmonth,
      tday,
      editing,
      cloudSecretV2,
      number,
      time
    ) => {
      const result = await analytics(
        fyear,
        fmonth,
        fday,
        tyear,
        tmonth,
        tday,
        editing,
        cloudSecretV2,
        number,
        time,
        selectedUser,
        myArray,
        search
      ).then(
        (result) => {
          setMedia(result.data ? result.data.rows : []);
        },
        (error) => {}
      );
      setLoading(false);
    };

    const date = () => {
      var day = { day: "numeric" };
      var month = { month: "numeric" };
      var year = { year: "numeric" };
      setTday(0 + new Date().toLocaleDateString([], day));
      setTmonth(0 + new Date().toLocaleDateString([], month));
      setTyear(new Date().toLocaleDateString([], year));
    };

    const oneMonth = () => {
      let today = new Date();

      var day = { day: "numeric" };
      var month = { month: "numeric" };
      var year = { year: "numeric" };

      today.setDate(today.getDate() - 30);

      setFday(0 + today.toLocaleDateString([], day));
      setFmonth(0 + today.toLocaleDateString([], month));
      setFyear(today.toLocaleDateString([], year));
    };
    date();
    oneMonth();
    videoDetail();

    if (
      fyear &&
      fmonth &&
      fday &&
      tyear &&
      tmonth &&
      tday &&
      editing.cloudKey &&
      editing.cloudSecretV2
    ) {
      mediaId(
        fyear,
        fmonth.slice(-2),
        fday.slice(-2),
        tyear,
        tmonth.slice(-2),
        tday.slice(-2),
        editing.cloudKey,
        editing.cloudSecretV2,
        number,
        time
      );
    }

    // eslint-disable-line react-hooks/exhaustive-deps
    //eslint-disable-next-line
  }, [
    fyear,
    fmonth,
    fday,
    tyear,
    tmonth,
    tday,
    editing.cloudKey,
    editing.cloudSecretV2,
    number,
    time,
    search,
  ]);
  const update = () => {
    setLoading(true);
    setTime("7 Days");
  };
  const mUpdate = () => {
    setLoading(true);
    setTime("30 Days");
  };
  const tMUpdate = () => {
    setLoading(true);
    setTime("90 Days");
  };
  const lUpdate = () => {
    setLoading(true);
    setTime("Last Quarter");
  };
  const mTDUpdate = () => {
    setLoading(true);
    setTime("Month To Date");
  };
  const TUpdate = () => {
    setLoading(true);
    setTime("Today");
  };
  const yUpdate = () => {
    setLoading(true);
    setTime("Yesterday");
  };
  const addNumber = async () => {
    let i = number + 1;
    setNumber(i);
    setLoading(true);
  };
  const minusNumber = async () => {
    let i = number - 1;
    setNumber(i);
    setLoading(true);
  };
  if (loading || media.length === 0) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ">
                <div className="card-header filter">
                  <h3 className="card-title">Video report</h3>

                  <ul className="navbar-nav ml-auto ">
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-widget="navbar-search"
                        href="#!"
                        role="button"
                        onClick={(event) => {
                          event.preventDefault();
                          setSearchOn(!searchOn);
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </a>
                      <div
                        className={
                          searchOn && editing.cloudKey && editing.cloudSecretV2
                            ? "navbar-search-block"
                            : "navbar-search-block none"
                        }
                      >
                        <form
                          className="form-inline"
                          onSubmit={(event) => {
                            event.preventDefault();
                            setSearch(true);
                            setTime("");
                            setLoading(true);
                          }}
                        >
                          <div className="input-group input-group-sm">
                            <label>From</label>&nbsp;
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="yyyy-mm-dd"
                              aria-label="yyyy-mm-dd"
                              value={selectedUser}
                              onChange={(event) => {
                                setSelectedUser(event.target.value);
                                setSearch(false);
                              }}
                            />
                            &nbsp;&nbsp;
                            <label>To</label>&nbsp;
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="yyyy-mm-dd"
                              aria-label="yyyy-mm-dd"
                              value={myArray}
                              onChange={(event) => {
                                setMyArray(event.target.value);
                                setSearch(false);
                              }}
                            />
                            <div className="input-group-append">
                              <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"></i>
                              </button>
                              <button
                                className="btn btn-navbar"
                                type="button"
                                data-widget="navbar-search"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setSearch(false);
                                  setSearchOn(false);
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                    <li>
                      <div className="btn-group">
                        <button type="button" className="btn btn-default">
                          {time ? time : "Time Frame"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-default dropdown-toggle dropdown-icon"
                          data-toggle="dropdown"
                          aria-expanded="false"
                          disabled={
                            editing.cloudKey && editing.cloudSecretV2
                              ? false
                              : true
                          }
                        >
                          <span className="sr-only">Toggle Dropdown</span>
                        </button>
                        <div className="dropdown-menu" role="menu">
                          <button
                            className="dropdown-item"
                            name="7 Days"
                            onClick={update}
                          >
                            7 Days
                          </button>
                          <button className="dropdown-item" onClick={mUpdate}>
                            30 days
                          </button>
                          <button className="dropdown-item" onClick={tMUpdate}>
                            90 Days
                          </button>
                          <button className="dropdown-item" onClick={lUpdate}>
                            Last Quarter
                          </button>
                          <button className="dropdown-item" onClick={mTDUpdate}>
                            Month to Date
                          </button>
                          <button className="dropdown-item" onClick={TUpdate}>
                            Today
                          </button>
                          <button className="dropdown-item" onClick={yUpdate}>
                            Yesterday
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <div style={{ paddingBottom: "60px" }}>
                              <table
                                id="appadmin"
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Media Id
                                    </th>
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Embeds
                                    </th>
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Plays
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Ad Impressions
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Completes
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Complete Rate
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Time Watched
                                    </th>
                                  </tr>
                                </thead>

                                {editing.cloudKey && editing.cloudSecretV2 && (
                                  <>
                                    <tbody>
                                      {media.map((person, index) => (
                                        <tr
                                          role="row"
                                          className="even"
                                          key={index}
                                        >
                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={0}
                                          >
                                            {person[0]}
                                          </td>

                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person[6]}
                                          </td>

                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person[1]}
                                          </td>

                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person[2]}
                                          </td>
                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person[3]}
                                          </td>
                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={2}
                                          >
                                            {person[4]}
                                          </td>
                                          <td>{person[5]}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </>
                                )}
                              </table>
                              {!(editing.cloudKey && editing.cloudSecretV2) && (
                                <>
                                  <div className="text-center mt-5">
                                    <h1> Please Enable Video Cloud</h1>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
                <div className="card-footer text-center">
                  <button
                    onClick={minusNumber}
                    disabled={number === 0 ? true : false}
                  >
                    <i className="fas fa-angle-left "></i>
                  </button>
                  &nbsp;{number}&nbsp;
                  <button
                    onClick={addNumber}
                    disabled={media.length < 10 ? true : false}
                  >
                    <i className="fas fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default VideoReport;
